const DEFAULT_BLOCKID = {
    event_whenstarted: 'vTJuU+VMuti*vv:#O.VP'
};

export {
    DEFAULT_BLOCKID
}